const onHome =
  (handler) =>
  (e, ...args) => {
    if (e.key === 'Home') {
      handler(e, ...args);
    }
  };

export default onHome;
